import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
    name: 'accessoryName'
})
export class AccessoryNamePipe implements PipeTransform {
    transform(accessory: any): string {
        if (!accessory) return '';
        let category = '';
        if (accessory?.accessoryCategory) {
          category = accessory?.accessoryCategory?.name || '';
        } else if (accessory?.accessory_category) {
          category = accessory?.accessory_category?.name || '';
        }
        let profile = '';
        if (accessory?.accessoryProfile) {
          profile = accessory?.accessoryProfile?.name || '';
        } else if (accessory?.accessory_profile) {
          profile = accessory?.accessory_profile?.name || '';
        }


        return category ? `${category} - ${profile}`.trim() : profile;
    }
}
